import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';

export default function About() {
  const aboutSchema = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于窝窝影院 - 免费在线观看平台',
    description:
      '窝窝影院是一个专注于免费在线影视观看的平台，提供电影、电视剧、综艺、动漫等海量高清资源，每日更新，全程无广告。',
    url: 'https://www.wowocinema.com/about',
    about: {
      '@type': 'Organization',
      name: '窝窝影院',
      description:
        '窝窝影院提供免费在线观看、免费影视资源，免费高清视频，免费追剧，最新电影电视剧大全不缓冲，无广告全部免费，每日更新精彩内容。',
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '窝窝影院是什么？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '窝窝影院是一个免费在线影视观看平台，提供电影、电视剧、综艺、动漫等多种类型的影视资源。所有资源均可免费观看，高清画质，流畅播放不缓冲。',
        },
      },
      {
        '@type': 'Question',
        name: '窝窝影院需要付费吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '不需要。窝窝影院完全免费，无需注册、无需付费，所有影视资源均可免费在线观看。',
        },
      },
      {
        '@type': 'Question',
        name: '窝窝影院有没有广告？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '窝窝影院致力于提供纯净的观影体验，播放全程无广告打扰，让用户享受沉浸式观影。',
        },
      },
      {
        '@type': 'Question',
        name: '窝窝影院的资源更新频率如何？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '窝窝影院每日更新最新影视资源，热门电影、电视剧、综艺节目第一时间上线，确保用户观看到最新内容。',
        },
      },
      {
        '@type': 'Question',
        name: '如何在窝窝影院找到想看的影片？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '您可以通过首页的分类导航进入电影、电视剧、综艺、动漫频道，也可以使用搜索功能快速找到想看的影片。每个分类页面还提供详细的子分类筛选。',
        },
      },
    ],
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(aboutSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      <Navbar />
      <ScrollToTop />
      <main className="pt-16">
        <div className="bg-background-100">
          <div className="max-w-7xl mx-auto">
            <Breadcrumb
              items={[
                { label: '首页', path: '/' },
                { label: '关于我们' },
              ]}
            />
          </div>
        </div>

        <section className="w-full px-4 md:px-6 py-10 md:py-14">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-4">
              关于窝窝影院
            </h1>
            <p className="text-sm text-foreground-600 leading-relaxed mb-8">
              窝窝影院是一个专注于提供免费在线影视观看服务的平台。我们致力于为全国观众提供最丰富的影视资源和最优质的观影体验，让每一位用户都能在这里找到自己喜欢的影片，享受纯粹的观影乐趣。
            </p>

            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-12">
              {[
                { number: '10万+', label: '影视资源' },
                { number: '5000万+', label: '月活跃用户' },
                { number: '99.9%', label: '播放成功率' },
                { number: '7年', label: '稳定运营' },
              ].map((stat, idx) => (
                <div key={idx} className="text-center p-4 bg-background-100 rounded-lg">
                  <div className="text-xl md:text-2xl font-heading font-bold text-primary-500">
                    {stat.number}
                  </div>
                  <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="space-y-10">
              <div>
                <h2 className="text-base md:text-lg font-heading font-semibold text-foreground-900 mb-3">
                  品牌介绍
                </h2>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  窝窝影院成立于2019年，经过多年发展，已经成为国内领先的免费在线影视平台。我们始终坚持"免费、高清、无广告"的核心理念，为亿万观众提供优质的在线观影服务。平台涵盖了电影、电视剧、综艺、动漫等多种类型的影视内容，并且保持每日更新，确保用户能够第一时间观看到最新的影视作品。
                </p>
              </div>

              <div>
                <h2 className="text-base md:text-lg font-heading font-semibold text-foreground-900 mb-3">
                  我们的优势
                </h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  {[
                    {
                      title: '海量资源库',
                      desc: '拥有超过10万部影视资源，涵盖电影、电视剧、综艺、动漫等全品类，满足不同用户的观影需求。',
                    },
                    {
                      title: '高清画质',
                      desc: '支持1080P高清播放，采用先进的视频编码技术，为用户带来极致的视觉体验。',
                    },
                    {
                      title: '极速播放',
                      desc: '部署全球CDN加速节点，确保视频播放流畅不缓冲，即使在网络条件不佳的情况下也能稳定播放。',
                    },
                    {
                      title: '零广告体验',
                      desc: '全程无广告打扰，让用户享受沉浸式的观影体验，这是我们一直坚持的承诺。',
                    },
                  ].map((item, idx) => (
                    <div key={idx} className="p-4 bg-background-100 rounded-lg">
                      <h3 className="text-sm font-heading font-semibold text-foreground-900 mb-2">
                        {item.title}
                      </h3>
                      <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
                    </div>
                  ))}
                </div>
              </div>

              <div>
                <h2 className="text-base md:text-lg font-heading font-semibold text-foreground-900 mb-3">
                  用户口碑
                </h2>
                <div className="space-y-3">
                  {[
                    {
                      name: '张先生',
                      text: '窝窝影院真的太好用了，资源全而且更新快，追剧首选！最重要的是完全没有广告，观影体验一级棒。',
                      rating: 5,
                    },
                    {
                      name: '李女士',
                      text: '用了很多影视平台，还是窝窝影院最稳定。画质清晰，不缓冲，而且完全免费，已经推荐给身边所有朋友了。',
                      rating: 5,
                    },
                    {
                      name: '王同学',
                      text: '作为学生党，窝窝影院简直就是福音。免费高清不卡顿，追番追剧两不误，强烈推荐！',
                      rating: 5,
                    },
                    {
                      name: '赵女士',
                      text: '窝窝影院的分类做得很清晰，找片很方便。更新速度也很快，新上的剧集当天就能看到，太良心了。',
                      rating: 4,
                    },
                  ].map((review, idx) => (
                    <div key={idx} className="p-4 bg-background-100 rounded-lg">
                      <div className="flex items-center gap-2 mb-2">
                        <div className="w-7 h-7 rounded-full bg-accent-100 flex items-center justify-center">
                          <span className="text-xs font-semibold text-accent-700">
                            {review.name.charAt(0)}
                          </span>
                        </div>
                        <span className="text-sm font-medium text-foreground-900">{review.name}</span>
                        <div className="flex items-center gap-0.5 ml-auto">
                          {Array.from({ length: review.rating }).map((_, i) => (
                            <i key={i} className="ri-star-fill text-accent-500 text-xs"></i>
                          ))}
                        </div>
                      </div>
                      <p className="text-xs text-foreground-600 leading-relaxed">{review.text}</p>
                    </div>
                  ))}
                </div>
              </div>

              <div>
                <h2 className="text-base md:text-lg font-heading font-semibold text-foreground-900 mb-3">
                  联系我们
                </h2>
                <div className="p-4 bg-background-100 rounded-lg space-y-2">
                  <div className="flex items-center gap-2">
                    <div className="w-7 h-7 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-mail-line text-primary-600 text-sm"></i>
                    </div>
                    <span className="text-sm text-foreground-700">contact@wowocinema.com</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <div className="w-7 h-7 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-customer-service-line text-primary-600 text-sm"></i>
                    </div>
                    <span className="text-sm text-foreground-700">在线客服：工作日 9:00 - 18:00</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <div className="w-7 h-7 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-wechat-line text-primary-600 text-sm"></i>
                    </div>
                    <span className="text-sm text-foreground-700">微信公众号：窝窝影院</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}